// extracted by mini-css-extract-plugin
export var askAiIcon = "_o1-j";
export var category = "_o1-9";
export var categoryHeader = "_o1-e";
export var container = "_o1-0";
export var group = "_o1-a";
export var groupItems = "_o1-f";
export var groupSeparator = "_o1-k";
export var loading = "_o1-1";
export var noResults = "_o1-3";
export var placeholder = "_o1-2";
export var resultContent = "_o1-5";
export var resultIcon = "_o1-c";
export var resultItem = "_o1-g";
export var resultMeta = "_o1-8";
export var resultSubtitle = "_o1-7";
export var resultSuffix = "_o1-i";
export var resultTitle = "_o1-6";
export var resultsList = "_o1-4";
export var searchGroup = "_o1-d";
export var selected = "_o1-h";
export var subgroup = "_o1-b";